<template>
  <div class="otp-sort-control">
    <label class="me-2">{{ $t('flexigo.otp.sortBy') }}</label>
    <select :value="value" class="form-select d-inline-block w-auto" @change="handleChange">
      <option value="onTimeAsc">{{ $t('flexigo.otp.onTimeAscending') }}</option>
      <option value="onTimeDesc">{{ $t('flexigo.otp.onTimeDescending') }}</option>
      <option value="lateAsc">{{ $t('flexigo.otp.lateAscending') }}</option>
      <option value="lateDesc">{{ $t('flexigo.otp.lateDescending') }}</option>
      <option value="earlyAsc">{{ $t('flexigo.otp.earlyAscending') }}</option>
      <option value="earlyDesc">{{ $t('flexigo.otp.earlyDescending') }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'OtpSortControl',
  props: {
    value: {
      type: String,
      default: 'onTimeAsc',
    },
  },
  methods: {
    handleChange(event) {
      this.$emit('input', event.target.value);
    },
  },
};
</script>

<style scoped>
.otp-sort-control {
  display: flex;
  align-items: center;
}
</style>
